import * as URLS_NEOADM from './URLS.constant';

export const ROLE_USER = require('./ROLE_USER.constant');

export { URLS_NEOADM };
